(function () {
  /* Slick needs jQuery. Both are loaded from cdnjs only if the theme doesn't already have them. */
  const JQUERY_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js';
  const SLICK_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';
  const scriptPromises = {};

  function loadScript(src) {
    if (!scriptPromises[src]) {
      scriptPromises[src] = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
      });
    }
    return scriptPromises[src];
  }

  function loadSlick() {
    const jqueryReady = window.jQuery ? Promise.resolve() : loadScript(JQUERY_SRC);
    return jqueryReady.then(() => (window.jQuery.fn.slick ? null : loadScript(SLICK_SRC))).then(() => window.jQuery);
  }

  if (customElements.get('new-featured-product')) return;

  class NewFeaturedProduct extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nfp__track');
      if (!this.track || this.track.children.length === 0) return;

      loadSlick()
        .then(($) => {
          if (!this.isConnected) return;
          this.init($);
        })
        .catch((error) => console.error('[New featured product]', error));
    }

    disconnectedCallback() {
      if (this.$track && this.$track.hasClass('slick-initialized')) {
        this.$track.slick('unslick');
      }
    }

    init($) {
      const data = this.dataset;
      const prevButton = this.querySelector('[data-nfp-prev]');
      const nextButton = this.querySelector('[data-nfp-next]');
      const dotsWrap = this.querySelector('.nfp__dots');
      const hasArrows = Boolean(prevButton && nextButton);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.$track = $(this.track);
      this.$track.slick({
        slidesToShow: parseInt(data.slidesDesktop, 10) || 3,
        slidesToScroll: 1,
        // No infinite loop: cloned slides would duplicate the quick add modals and form IDs
        infinite: false,
        autoplay: data.autoplay === 'true',
        autoplaySpeed: parseInt(data.autoplaySpeed, 10) || 5000,
        pauseOnHover: true,
        speed: reduceMotion ? 0 : 500,
        cssEase: 'ease',
        rows: 0,
        swipeToSlide: true,
        touchThreshold: 8,
        arrows: hasArrows,
        prevArrow: hasArrows ? prevButton : undefined,
        nextArrow: hasArrows ? nextButton : undefined,
        dots: Boolean(dotsWrap),
        appendDots: dotsWrap ? $(dotsWrap) : undefined,
        // Breakpoints match the CSS: below 990px = tablet, below 750px = mobile
        responsive: [
          { breakpoint: 990, settings: { slidesToShow: parseInt(data.slidesTablet, 10) || 2 } },
          { breakpoint: 750, settings: { slidesToShow: parseInt(data.slidesMobile, 10) || 1 } },
        ],
      });
    }
  }

  customElements.define('new-featured-product', NewFeaturedProduct);
})();
